<template>
  <div class="cn" v-if="isChinese()"  >
    <span
      style="
        margin-top: 40px;
        font-size: 30px;
        display: block;
        text-align: center;
      "
      >
      隐私政策</span
    >
    <textarea
      disabled="true"
      style="
        padding-top: 60px;
        height: 2000px;
        width: 100%;
        font-size: 18px;
        border: none;
        resize: none;
      "
    >

隐私政策

应用名称：FINDPOP
开发者信息：深圳市控比灯科技合伙企业（普通合伙）
生效日期：2024年3月4日

一、数据收集

当用户使用我们的应用程序时，我们会通过应用程序收集以下信息：

我们可能会收集有关用户设备的信息，例如设备型号、操作系统版本、唯一设备标识符和移动网络信息。
应用程序使用情况信息：我们可能会收集有关应用程序的使用情况，例如应用程序打开次数、使用时长和功能使用情况。
错误日志信息：如果应用程序发生错误，我们可能会收集有关错误的信息，例如错误类型和错误发生时间。
当应用程序通过蓝牙或Wi-Fi连接到灯串设备时会收集灯串的信息。
位置信息：指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息。在安卓手机上进行蓝牙扫描需要打开定位开关并且获取您的授权，以便您可以连接到附近的灯串设备。
录音信息：指您使用音乐律动功能时，采集麦克风数据并进行分析，以便您可以通过声音控制灯串。
修改或删除存储卡上的照片、媒体内容和文件：指您使用涂鸦-图片转化功能时，应用程序需要获取存储权限，以便您从本机图片中选择一张图片。
读取存储卡上的照片、媒体内容和文件：指您使用涂鸦-图片转化功能时，应用程序需要获取存储权限，以便您从本机图片中选择一张图片。
微软的App Center数据收集：

App Center Analytics数据： 我们通过微软的App Center Analytics SDK收集有关应用程序使用情况的数据，包括但不限于用户交互、页面浏览、事件触发等信息，以帮助我们更好地了解用户行为和优化应用体验。

App Center Diagnostics数据： 我们使用微软的App Center Diagnostics SDK来收集应用程序的崩溃日志和错误信息，以便我们能够更快速地识别和解决应用程序的问题，提高应用的稳定性。

请注意，我们将确保微软的App Center Analytics和App Center Diagnostics仅用于上述目的，并不会将其数据用于任何其他目的。我们将继续采取合理的技术和组织措施来保护用户的个人数据安全。

二、数据收集目的

应用程序收集数据的目的是优化用户体验，确保应用程序的稳定性和安全性，以及帮助我们改进应用程序功能。

三、数据共享

微软的App Center Analytics和App Center Diagnostics数据仅用于应用程序优化和错误调试的目的，我们不会向第三方出售、交易或转让这些数据。

四、账户和个人信息

在用户使用我们的应用程序时，可能需要创建个人账户，以确保您可以享受更多个性化的服务。在这种情况下，我们会收集以下信息：

用户账户信息： 包括但不限于用户昵称、电子邮件地址和密码。这些信息将用于验证用户身份和确保账户安全。
个人资料： 用户可以选择提供一些个人信息，如性别、出生日期等，以获取更加个性化的服务体验。提供这些信息是自愿的，用户可以随时更改或删除这些信息。
其他信息： 在使用特定功能时，我们可能会收集额外的信息，例如地址、联系方式等，以提供相关服务。用户提供这些信息是可选的，但可能会影响某些功能的可用性。
请注意，我们会采取合理的技术和组织措施，保护用户提供的个人信息的安全性。我们承诺不会将这些信息用于任何其他目的，除非用户事先同意或法律规定允许这样做。

微软的隐私声明链接：
https://privacy.microsoft.com/privacystatement

如果用户选择不创建个人账户，仍可使用应用程序的基本功能，但可能无法享受个性化的服务体验。我们将尽最大努力保护用户的个人数据安全，并遵守相关法规和政策。如果您对我们处理个人信息的方式有任何疑问或顾虑，请通过以下联系方式与我们联系：

电子邮件：support@findpop.net

感谢您的理解和支持！
  </textarea
    >
  </div>

  <div class="en"   v-if="!isChinese()" >
    <span
      style="
        margin-top: 40px;
        font-size: 30px;
        display: block;
        text-align: center;
      "
    >
      Privacy Policy</span
    >

    <textarea
      style="
        padding-top: 60px;
        height: 1500px;
        width: 100%;
        font-size: 18px;
        border: none;
        resize: none;
      "
    >

Privacy Policy

Application Name: FINDPOP
Developer Information: Shenzhen KBD Technology Partnership
Effective Date: March 4, 2024

I. Data Collection

When users utilize our application, we collect the following information through the application:

1. We may collect information about the user's device, such as device model, operating system version, unique device identifier, and mobile network information.
2. Application usage information: We may collect data on the usage of the application, including the number of times the application is opened, usage duration, and feature usage.
3. Error log information: In the event of application errors, we may collect details about the error, such as error type and the time it occurred.
4. Information about light string devices when the application is connected to them via Bluetooth or Wi-Fi.
5. Location information: When users enable the device's location feature and use location-based services provided by us, we collect information about their location. On Android phones, turning on the location switch and obtaining user authorization is necessary for Bluetooth scanning, allowing connection to nearby light string devices.
6. Recording information: When users use the music rhythm feature, we collect microphone data for analysis, enabling users to control light strings through sound.
7. Modification or deletion of photos, media content, and files on the storage card: When using the Doodle-Image Conversion feature, the application needs storage permission to allow users to select an image from local photos.
8. Reading photos, media content, and files from the storage card: When using the Doodle-Image Conversion feature, the application needs storage permission to allow users to select an image from local photos.

Microsoft's App Center Data Collection:

9. App Center Analytics Data: We collect data on the usage of the application, including but not limited to user interactions, page views, and triggered events, through Microsoft's App Center Analytics SDK. This helps us better understand user behavior and optimize the application experience.

10. App Center Diagnostics Data: We use Microsoft's App Center Diagnostics SDK to collect crash logs and error information from the application. This enables us to quickly identify and resolve application issues, improving its stability.

Please note that we will ensure that Microsoft's App Center Analytics and App Center Diagnostics are only used for the purposes mentioned above and will not use their data for any other purposes. We will continue to implement reasonable technical and organizational measures to protect the security of user's personal data.

II. Purpose of Data Collection

The purpose of collecting application data is to optimize user experience, ensure the stability and security of the application, and assist us in improving application functionality.

III. Data Sharing

Data collected through Microsoft's App Center Analytics and App Center Diagnostics is only used for application optimization and error debugging. We do not sell, trade, or transfer this data to third parties.

IV. Accounts and Personal Information

When users use our application, it may be necessary to create a personal account to ensure access to more personalized services. In such cases, we collect the following information:

1. User Account Information: This includes, but is not limited to, user nicknames, email addresses, and passwords. This information is used to verify user identity and ensure account security.
2. Personal Profile: Users can choose to provide additional personal information, such as gender and birthdate, for a more personalized service experience. Providing this information is voluntary, and users can change or delete it at any time.
3. Other Information: When using specific features, we may collect additional information such as addresses and contact details to provide relevant services. Providing this information is optional but may affect the availability of certain features.

Please note that we will implement reasonable technical and organizational measures to protect the security of user-provided personal information. We commit not to use this information for any purposes other than those mentioned, except with the user's prior consent or as permitted by law.

Microsoft's Privacy Statement Link:
https://privacy.microsoft.com/privacystatement

If users choose not to create a personal account, they can still use the basic functionality of the application but may not enjoy a personalized service experience. We will make every effort to protect the security of user's personal data and comply with relevant regulations and policies. If you have any questions or concerns about how we handle personal information, please contact us via the following email address:

Email: support@findpop.net

Thank you for your understanding and support!


</textarea
    >
  </div>
</template>

<script setup>
function isChinese(){
 return navigator.language.indexOf('zh')>=0
}
</script>

<style>
</style>